import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import useStyles from './styles';

function ProgressBar({
  totalProjects,
  numberOfProjectsWithNextMonthDemand,
}) {
  const classes = useStyles();
  // caso en que min y max son 0

  const series = [
    {
      color: '#BDBDBD',
      data: [totalProjects - numberOfProjectsWithNextMonthDemand],
      stack: 'stack1',
    },
    {
      color: '#24335E',
      data: [numberOfProjectsWithNextMonthDemand],
      stack: 'stack1',
    },

  ];

  const options = {
    chart: {
      type: 'bar',
      height: '100px',
    },
    title: {
      text: '',
    },
    xAxis: {
      labels: {
        enabled: false,
      },
      gridLineWidth: 0,
      lineWidth: 0,
      tickWidth: 0,
    },
    yAxis: {
      stackLabels: {
        enabled: false,
      },
      title: {
        enabled: false,
      },
      labels: {
        enabled: false,
      },
      gridLineWidth: 0,
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      series: {
        stacking: 'normal',
      },
    },
    series,
  };

  return (
    <div className={classes.progressBarDisplay}>
      <HighchartsReact highcharts={Highcharts} options={options} />
      <span className={classes.progressBarText}>
        {numberOfProjectsWithNextMonthDemand}/{totalProjects}
      </span>
    </div>
  );
}

ProgressBar.propTypes = {
  totalProjects: PropTypes.number,
  numberOfProjectsWithNextMonthDemand: PropTypes.number,
};
export default ProgressBar;
